import 'intersection-observer'

export default defineNuxtPlugin((nuxtApp) => {
  //nothing needed, the import handles the polyfill
})
